import { NamedType } from "src/app/core.models/named-type";
import { getFieldsFromInstance } from "src/app/core.utilidades/graphql-utils";

/**
 * Desglose de precios de UNA modalidad de forma de pago (Anual, Semestral,
 * Trimestral o Mensual) tal y como lo calcula el backend (PLAN-011 / ISSUE-012).
 *
 * El front NO calcula: solo transporta y presenta estos valores (con Math.ceil).
 *
 * Todos los campos se inicializan en el constructor porque getFieldsFromInstance
 * solo pide en la query GraphQL los campos que existen en la instancia: si alguno
 * no se inicializa, el backend no lo devuelve y el valor queda como undefined.
 */
export class PreciosModalidad implements NamedType {
    // evita perder el nombre de clase cuando ivy realiza las optimizaciones de produccion
    _className: string = 'PreciosModalidad';

    recargo: number;
    recibos: number;
    pnFallecimiento: number;
    pnFallecimientoAccidente: number;
    pnIpa: number;
    pnTotal: number;
    consorcio: number;
    clea: number;
    ips: number;
    pt: number;
    primerRecibo: number;
    primerReciboFallecimiento: number;
    primerReciboFallecimientoAccidente: number;
    primerReciboIncapacidad: number;
    restoRecibo: number;
    precioMensualFallecimiento: number;
    precioMensualFallecimientoAccidente: number;
    precioMensualIncapacidad: number;
    primaMinimaSuperada: boolean;

    constructor() {
        this.recargo = 0;
        this.recibos = 0;
        this.pnFallecimiento = 0;
        this.pnFallecimientoAccidente = 0;
        this.pnIpa = 0;
        this.pnTotal = 0;
        this.consorcio = 0;
        this.clea = 0;
        this.ips = 0;
        this.pt = 0;
        this.primerRecibo = 0;
        this.primerReciboFallecimiento = 0;
        this.primerReciboFallecimientoAccidente = 0;
        this.primerReciboIncapacidad = 0;
        this.restoRecibo = 0;
        this.precioMensualFallecimiento = 0;
        this.precioMensualFallecimientoAccidente = 0;
        this.precioMensualIncapacidad = 0;
        this.primaMinimaSuperada = false;
    }

    public static getFields = () => {
        const fields: string = getFieldsFromInstance(new PreciosModalidad());
        return fields.split('id ').join('');
    };

}
